<template>
<a-modal
  width="760px"
  title="团队管理"
  v-model:visible="visible">
  <a-form ref="form"
    class="form"
    layout="inline"
    :rules="rules"
    :model="form"
    :labelCol="{ span: 6 }"
    :wrapperCol="{ span: 18 }">
    <a-form-item label="公司名称">
      <span>{{ getCompanyName(currentRole.companyId) }}</span>
    </a-form-item>
    <a-form-item v-if="dialogType !== 'add'" label="团队编号">
      <span>{{ form.id }}</span>
    </a-form-item>
    <a-form-item label="团队名称" name="name">
      <span v-if="actionType === 'detail'">{{ currentItem.name }}</span>
      <a-input v-else v-model:value="form.name" autocomplete="off"></a-input>
    </a-form-item>
    <a-form-item label="状态" name="state">
      <span v-if="actionType === 'detail'">{{ getState(currentItem.state) }}</span>
      <a-select
        v-else
        style="width: 140px"
        v-model:value="form.state">
        <a-select-option key="open">启用</a-select-option>
        <a-select-option key="close">停用</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="电话" name="phoneNumber">
      <span v-if="actionType === 'detail'">{{ currentItem.phoneNumber }}</span>
      <a-input v-else v-model:value="form.phoneNumber" autocomplete="off"></a-input>
    </a-form-item>
    <a-form-item label="邮箱" name="email">
      <span v-if="actionType === 'detail'">{{ currentItem.email }}</span>
      <a-input v-else v-model:value="form.email" autocomplete="off"></a-input>
    </a-form-item>
  </a-form>
  <div class="member-list" v-if="dialogType !== 'add'">
    <div class="paragraph-title">
      团队成员
    </div>
    <div class="member-item" style="margin-bottom: 10px">
      <p class="cell1">姓名</p>
      <p class="cell2">角色</p>
    </div>
    <div class="member-item" style="margin-bottom: 10px">
      <p class="cell1">姓名</p>
      <p class="cell2">角色</p>
    </div>
    <div class="member-item"
      v-for="(item, index) in memberList"
      :key="index">
      <p class="cell1">{{ getUserName(item.userId) }}</p>
      <p class="cell2">{{ getRoleName(item.roleId) }}</p>
    </div>
  </div>
  <template #footer>
    <a-button type="primary" @click="setEdit" v-if="actionType === 'detail'">
      编辑
    </a-button>
    <a-button key="back" @click="visible = false" v-if="actionType !== 'detail'">
      取消
    </a-button>
    <a-button key="submit" type="primary" @click="handleSubmit" v-if="actionType !== 'detail'">
      保存
    </a-button>
  </template>
</a-modal>
</template>
<script>
import { mapState } from 'vuex'
import { getTeamMember, addTeam, updateTeam } from '@/api/team'
import { getCompanyName, getState, getUserName, getRoleName } from '@/filters'
const noSpeChar = async (rule, value) => {
  if (!/^[a-zA-Z0-9\u4e00-\u9fa5_-]+$/.test(value)) {
    return Promise.reject(new Error('团队名称不能有特殊字符'))
  }
}
export default {
  props: {
    dialogType: {
      type: String,
      default: 'add'
    },
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visible: false,
      actionType: 'add',
      form: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '团队名称不能为空', trigger: 'blur' },
          { min: 1, max: 24, message: '团队名称不能超过24个字符', trigger: 'blur' },
          { validator: noSpeChar, trigger: 'blur' }
        ]
      },
      memberList: []
    }
  },
  computed: {
    ...mapState(['currentRole'])
  },
  methods: {
    getCompanyName,
    getState,
    getUserName,
    getRoleName,
    open () {
      this.visible = true
      console.log(this.currentRole)
      this.$nextTick(() => {
        this.actionType = this.dialogType
        if (this.actionType === 'detail') {
          this.form = {
            id: this.currentItem.id,
            name: this.currentItem.name,
            state: this.currentItem.state,
            phoneNumber: this.currentItem.phoneNumber,
            email: this.currentItem.email
          }
          this.$refs.form.clearValidate()
          if (this.form.id) {
            getTeamMember({
              teamId: this.form.id,
              pageNum: 1,
              pageSize: 10000
            }).then(async res => {
              this.memberList = res.data.map.data.rows
            })
          }
        } else {
          this.form = {
            name: '',
            state: 'open',
            phoneNumber: '',
            email: ''
          }
          this.$refs.form.clearValidate()
        }
      })
    },
    setEdit () {
      this.actionType = 'edit'
    },
    handleSubmit () {
      if (this.actionType === 'detail') {
        this.visible = false
      } else {
        this.$refs.form.validate().then(() => {
          const action = this.actionType === 'add' ? addTeam : updateTeam
          action({
            ...this.form,
            companyId: this.currentRole.companyId
          }).then(res => {
            console.log(res)
            this.$message.success('操作成功')
            this.$emit('update')
            this.visible = false
            this.$store.dispatch('updateTeamList')
          }).catch(e => {
            this.$message.error('操作失败')
          })
        }).catch(() => {

        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.form {
  .ant-form-item {
    width: 330px;
  }
}
.member-list {
  width: 600px;
  display: flex; flex-wrap: wrap;
  border: 1px solid #e2e2e2;
  padding: 10px;
  .paragraph-title {
    margin-bottom: 10px;
    width: 100%; font-size: 16px;
    display: flex;
  }
  .member-item {
    width: 50%;
    display: flex;
    .cell1 {
      width: 40%;
    }
    .cell2 {
      width: 60%;
    }
  }
}
</style>
